import React from 'react';

export const SkeletonCard = ({ className = '' }) => (
  <div className={`card p-6 animate-pulse ${className}`}>
    <div className="space-y-3">
      <div className="h-4 bg-dark-700 rounded w-3/4"></div>
      <div className="h-3 bg-dark-700 rounded w-1/2"></div>
      <div className="h-3 bg-dark-700 rounded w-2/3"></div>
    </div>
  </div>
);

export const SkeletonServiceCard = ({ className = '' }) => (
  <div className={`card p-6 animate-pulse hover:border-primary-500/50 transition-all ${className}`}>
    <div className="flex items-center gap-4">
      <div className="w-12 h-12 bg-dark-700 rounded-lg"></div>
      <div className="flex-1">
        <div className="h-5 bg-dark-700 rounded w-1/2 mb-2"></div>
        <div className="h-4 bg-dark-700 rounded w-1/3"></div>
      </div>
      <div className="h-6 bg-dark-700 rounded w-16"></div>
    </div>
  </div>
);

export const SkeletonBarberCard = ({ className = '' }) => (
  <div className={`card p-6 animate-pulse hover:border-primary-500/50 transition-all cursor-pointer ${className}`}>
    <div className="flex items-center gap-4">
      <div className="w-16 h-16 bg-dark-700 rounded-full"></div>
      <div className="flex-1">
        <div className="h-5 bg-dark-700 rounded w-1/3 mb-2"></div>
        <div className="h-4 bg-dark-700 rounded w-1/2"></div>
      </div>
    </div>
  </div>
);

export const SkeletonTimeSlot = ({ className = '' }) => (
  <div className={`card p-4 animate-pulse hover:border-primary-500/50 transition-all cursor-pointer ${className}`}>
    <div className="h-4 bg-dark-700 rounded w-12"></div>
  </div>
);

export const SkeletonReviewCard = ({ className = '' }) => (
  <div className={`card p-5 animate-pulse border border-dark-700 ${className}`}>
    <div className="flex items-start gap-3 mb-3">
      <div className="w-10 h-10 bg-dark-700 rounded-full"></div>
      <div className="flex-1">
        <div className="h-4 bg-dark-700 rounded w-1/3 mb-2"></div>
        <div className="flex gap-1">
          {[...Array(5)].map((_, i) => (
            <div key={i} className="w-3 h-3 bg-dark-700 rounded"></div>
          ))}
        </div>
      </div>
    </div>
    <div className="space-y-2">
      <div className="h-3 bg-dark-700 rounded w-full"></div>
      <div className="h-3 bg-dark-700 rounded w-4/5"></div>
    </div>
  </div>
);

export const SkeletonHero = () => (
  <div className="animate-pulse">
    <div className="flex flex-col lg:flex-row items-center gap-8">
      <div className="flex-1 text-center lg:text-left">
        <div className="h-12 bg-dark-700 rounded w-3/4 mb-4"></div>
        <div className="h-6 bg-dark-700 rounded w-full mb-6"></div>
        <div className="flex items-center justify-center lg:justify-start gap-6 mb-8">
          <div className="h-8 bg-dark-700 rounded w-24"></div>
          <div className="h-8 bg-dark-700 rounded w-20"></div>
        </div>
        <div className="h-10 bg-dark-700 rounded w-32"></div>
      </div>
      <div className="w-64 h-64 bg-dark-700 rounded-full"></div>
    </div>
  </div>
);

export const SkeletonStatsCard = ({ className = '' }) => (
  <div className={`card p-6 animate-pulse ${className}`}>
    <div className="flex items-center justify-between">
      <div>
        <div className="h-3 bg-dark-700 rounded w-16 mb-2"></div>
        <div className="h-8 bg-dark-700 rounded w-20"></div>
      </div>
      <div className="w-12 h-12 bg-dark-700 rounded-lg"></div>
    </div>
  </div>
);

export const SkeletonAppointmentCard = ({ className = '' }) => (
  <div className={`card p-4 animate-pulse ${className}`}>
    <div className="flex items-center justify-between mb-3">
      <div className="h-4 bg-dark-700 rounded w-1/3"></div>
      <div className="h-6 bg-dark-700 rounded w-20"></div>
    </div>
    <div className="space-y-2">
      <div className="h-3 bg-dark-700 rounded w-2/3"></div>
      <div className="h-3 bg-dark-700 rounded w-1/2"></div>
    </div>
  </div>
);

export const SkeletonQuickInfoCard = ({ className = '' }) => (
  <div className={`card p-4 animate-pulse hover:border-primary-500/50 transition-all ${className}`}>
    <div className="flex items-center gap-3">
      <div className="w-10 h-10 bg-dark-700 rounded-lg"></div>
      <div className="flex-1">
        <div className="h-4 bg-dark-700 rounded w-1/3 mb-1"></div>
        <div className="h-3 bg-dark-700 rounded w-full"></div>
      </div>
    </div>
  </div>
);

export const SkeletonTable = ({ rows = 5, className = '' }) => (
  <div className={`animate-pulse ${className}`}>
    <div className="space-y-3">
      {[...Array(rows)].map((_, i) => (
        <div key={i} className="flex items-center gap-4 p-4 border border-dark-700 rounded">
          <div className="h-4 bg-dark-700 rounded w-16"></div>
          <div className="h-4 bg-dark-700 rounded w-24"></div>
          <div className="h-4 bg-dark-700 rounded w-20"></div>
          <div className="h-4 bg-dark-700 rounded w-28"></div>
          <div className="h-4 bg-dark-700 rounded w-16"></div>
        </div>
      ))}
    </div>
  </div>
);

export const SkeletonForm = ({ fields = 3, className = '' }) => (
  <div className={`animate-pulse ${className}`}>
    <div className="space-y-4">
      {[...Array(fields)].map((_, i) => (
        <div key={i}>
          <div className="h-4 bg-dark-700 rounded w-24 mb-2"></div>
          <div className="h-10 bg-dark-700 rounded w-full"></div>
        </div>
      ))}
    </div>
  </div>
);

export const SkeletonLoading = ({ type = 'card', className = '', ...props }) => {
  const skeletons = {
    card: <SkeletonCard className={className} />,
    service: <SkeletonServiceCard className={className} />,
    barber: <SkeletonBarberCard className={className} />,
    timeSlot: <SkeletonTimeSlot className={className} />,
    review: <SkeletonReviewCard className={className} />,
    hero: <SkeletonHero />,
    stats: <SkeletonStatsCard className={className} />,
    appointment: <SkeletonAppointmentCard className={className} />,
    quickInfo: <SkeletonQuickInfoCard className={className} />,
    table: <SkeletonTable {...props} className={className} />,
    form: <SkeletonForm {...props} className={className} />
  };

  return skeletons[type] || skeletons.card;
};

export default SkeletonLoading;
